import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ReportService, UserService } from '../../_services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalDataService } from '../../_shared';
import { EnterVoWD, Supplier, Report, DropAmtComnt, LoginUser , CostCenter} from '../../_models';
import { ModalPopupAlertComponent } from '../../_shared/modal-popup-alert/modal-popup-alert.component';
import * as XLSX from 'xlsx'; 
import { Subscription, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-drop-analysis-contract',
  templateUrl: './drop-analysis-contract.component.html',
  styleUrls: ['./drop-analysis-contract.component.css']
})
export class DropAnalysisContractComponent implements OnInit {
  ChkAll: any =false;
  ChkOne: any =false;
  config: any;
  rptData = new Report();
  dropAmtComnt = new DropAmtComnt();
  CostCentersResult: CostCenter[] = [];
  lstContract: string[] = [];
   SupplierAB!: string | null;
   SupName = ''; 
   DropID=0;
   ObjectAccount = '';  
   ObjectAccountDesr = ''; 
   Area!: string | null;
   Contract!: string;
  Department!: string | null;
  arrayListArea: Array<string> = [];
  arrayListDepartment: Array<string> = [];
  arrayListAreaDistinct: Array<string> = [];
  arrayListDepartmentDistinct: Array<string> = [];
   Year = '';  
   cmd = 'DROP';
   Month='';
   Drop:number=0;
   ExistingDrop:number=0;
   FractionDrop:number[] = [];
   Adjust:number = 0;
   DropComments='';
   Remarks='';
  dropAnalysisResult: any[] = [];
  resVowdList: any[] = [];
  dropAnalysisView = new EnterVoWD();
  suppliersResult: Supplier[] = [];
  objectAccountsResult: string[] = [];
  getMonths: string[] = [];
  getYrs : string[]=[];
  user: LoginUser = new LoginUser;
  flgLock: boolean = false;
  subscription: Subscription = new Subscription;
   DropsAdjumntSum!: number;
   PendingAccural!: number;
   results!: Observable<Supplier[]>;  
   loading: boolean = true; 
   resultsObj!: Observable<string[]>; 
  private searchTermsObj = new Subject<string>();  
  FrmDt!: string | number | Date;
  ToDt: any ;
  ApprDt!: { year: number; month: number; day: number; };
  arrayList: Array<string> = [];
  @ViewChild('TABLE', { static: false })
  TABLE!: ElementRef;  
  title = 'Excel';  
  errDrop: boolean = false;
  errDropCmt: boolean = false;
  vowdTotal: number=0;
  vowdInv: number=0;
  vowdAdj: number=0;
  vowdDrp: number=0;
  vowdOvp: number=0;
  vowdAccr: number=0;
  vowdCont: number=0;
  Droptxt: boolean = false;
  Adjustmentxt: boolean = true;

  constructor(
    private reportService  : ReportService,
    private userService : UserService,
    private gd : GlobalDataService,
    private modalService: NgbModal
  ){ }

  ExportTOExcel() {   
 
      var reportGrid = document.getElementById("reportGrid_all");
      var wb: XLSX.WorkBook = XLSX.utils.book_new();
      let ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(reportGrid);
      wb.SheetNames.push("Sheet1");
      wb.Sheets["Sheet1"] = ws;
  
      /* save to file */
      XLSX.writeFile(wb, 'AccrualCalc' + new Date().toDateString() + '_' + new Date().getTime().toString() + '.xlsx');
  } 

  ngOnInit() {
    this.user = this.gd.getUserData();
    this.Droptxt = false;
    this.Adjustmentxt = true;
    this.getSuppliers();
    this.getObjectAccount();
    this.getCenterData();
    this.getMonths = this.gd.monthNames;
    this.Month = this.gd.monthNames[new Date().getMonth()];
    this.getAcurlYr();
    this.GetApprovedDate()
    this.getContractData("Null");
  }

  getContractData(SupplierID:string){
    this.userService.getContractData(SupplierID).subscribe(data=>{
      this.lstContract = data;     
      });
  }
  
  GetApprovedDate(){
    this.reportService.getApprovedDate().subscribe(res => {
      if(res!=null)
      {
        this.ApprDt = {
          "year": new Date(res.ApproveDate).getFullYear(),
          "month":  new Date(res.ApproveDate).getMonth()+1,
          "day": new Date(res.ApproveDate).getDate()
        }
      }
    });
  }
  getCenterData()
  {
    this.CostCentersResult= this.gd.getCostCenterData();
    this.arrayListArea = this.CostCentersResult.map(cost => cost.Area_CODE +"-" +cost.Area_description); 
    this.arrayListDepartment = this.CostCentersResult.map(cost =>cost.Division); 
    this.arrayListAreaDistinct = this.arrayListArea.filter((n, i) => this.arrayListArea.indexOf(n) === i);
    this.arrayListDepartmentDistinct = this.arrayListDepartment.filter((n, i) => this.arrayListDepartment.indexOf(n) === i);
  }
  searchArea = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayListAreaDistinct.filter(v => v!=null && v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )

  searchDepartment = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayListDepartmentDistinct.filter(v => v!=null && v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )
  getSuppliers()
  {
   
    this.suppliersResult= this.gd.getSupplierData();
    this.arrayList = this.suppliersResult.map(sup => sup.SupplierAB.toString().trim() +"-" +sup.SupplierName.toString().trim()); 
  }

  searchSupplier = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayList.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )

  searchContract = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.lstContract.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )
  searchObjectAcnt = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.objectAccountsResult.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )

  selectedAll(chk :boolean) {
   
     for (var i = 0; i < this.dropAnalysisResult.length; i++) {
       this.dropAnalysisResult[i].selected = chk;
     }
   }

  selectedOne(dropAnalysis : any) {
    this.ChkOne=this.ChkOne==false ? true :false;
    this.CalculateAccural(dropAnalysis,this.ChkOne);
  }

  getDropAnanlysis(type:string)
  {
    this.PrepareReportData();
    if(type=='search')
    {
         this.ChkAll =false;
         this.getDropAmtComnt();
    }
    if(type=='calc')
    {
        if(this.DropComments.length < 20)
          this.errDropCmt =true;
        else{
          this.resVowdList=this.dropAnalysisResult.filter(t=>t.selected == true);
          if(this.resVowdList.length>0)
          {
            
            this.vowdDrp =0;this.vowdAccr=0;
            if(this.resVowdList.length==1){
              this.ExistingDrop = this.resVowdList[0].Drops ;
              if(!this.Droptxt)
              {
                this.resVowdList[0].Drops = this.ConvertToInt(this.Drop) + this.ConvertToInt(this.ExistingDrop) ;
                this.Remarks = 'Drop';
              }else
              {
                this.resVowdList[0].Drops = this.ConvertToInt(this.Adjust) + this.ConvertToInt(this.ExistingDrop);
                this.Remarks = 'Adjustment';
              }
              
              let accrualRes =( this.resVowdList[0].VOWDAmount -this.resVowdList[0].Invoice -this.resVowdList[0].Adjustment-this.resVowdList[0].Drops);
              this.resVowdList[0].Accrual= accrualRes <0 ?0:accrualRes;
              this.resVowdList[0].Remarks = this.Remarks;
            }
            else{
                  var sumOfVOWD=0;var sumOfInvoice=0;
                  for(let i=0; i < this.resVowdList.length;i++){
                    sumOfVOWD =sumOfVOWD + this.resVowdList[i].VOWDAmount;
                    sumOfInvoice =sumOfInvoice +this.resVowdList[i].Invoice;
                  } 
                  var absDiff = Math.abs(sumOfVOWD-sumOfInvoice);
                  var dropValue = this.Droptxt ? this.Adjust : this.Drop ;
                  var perDrop = ((dropValue/absDiff)*100) ;
                  for(let i=0; i < this.resVowdList.length;i++)
                  {
                    this.FractionDrop[i] = ((this.resVowdList[i].Accrual * perDrop)/100)
                    this.resVowdList[i].Drops=  this.ConvertToInt(((this.resVowdList[i].Accrual * perDrop)/100)) + this.ConvertToInt(this.resVowdList[i].Drops); 
                    let accrual =( this.resVowdList[i].VOWDAmount -this.resVowdList[i].Invoice -this.resVowdList[i].Adjustment-this.resVowdList[i].Drops); 
                    this.resVowdList[i].Accrual= accrual <0 ?0:accrual;
                    this.resVowdList[i].Remarks = this.Droptxt ? 'Adjustment' : 'Drop' ;
                  
                  }
                 
              }
              for (let i=0;i<this.dropAnalysisResult.length;i++)
              {
                this.vowdDrp = (this.vowdDrp + this.dropAnalysisResult[i].Drops) ;
                this.vowdAccr = (this.vowdAccr + this.dropAnalysisResult[i].Accrual) ;
              }
            this.CalcDropAmtComnt();
          }
          else
          {
            this.openAlertModal("Please Select Record To be drop");
            return;
          }
         
        
          this.errDrop =false;
          this.errDropCmt =false;
        }  
     
    }
    

 
  }
  SearchDropAnalysisReport()
  {
    this.reportService.getAllContractReportSearch(this.rptData).subscribe(data=>{
      this.dropAnalysisResult = data;
      this.vowdTotal=0;this.vowdInv=0;this.vowdAdj=0;this.vowdDrp=0;this.vowdOvp=0;this.vowdAccr=0;this.vowdCont =0;
      for (let i=0;i<this.dropAnalysisResult.length;i++)
      {
        this.vowdTotal =(this.vowdTotal + this.dropAnalysisResult[i].VOWDAmount) ;
        this.vowdInv = (this.vowdInv + this.dropAnalysisResult[i].Invoice) ;
        this.vowdAdj = (this.vowdAdj + this.dropAnalysisResult[i].Adjustment) ;

        this.vowdDrp = (this.vowdDrp + this.dropAnalysisResult[i].Drops) ;
        this.vowdOvp = (this.vowdOvp + this.dropAnalysisResult[i].Overpayments) ;
        this.vowdAccr = (this.vowdAccr + this.dropAnalysisResult[i].Accrual) ;
        this.vowdCont = (this.vowdCont + this.dropAnalysisResult[i].ContractAmount);
        this.dropAnalysisResult[i].ObjDescr = this.objectAccountsResult.filter(t=>t.split('-')[0].trim()== this.dropAnalysisResult[i].ObjectAccount.trim())[0];
      }
     
      this.config = {
        itemsPerPage: 10,
        currentPage: 1,
        totalItems: this.dropAnalysisResult.length
      };
      });
      this.subscription = this.gd.flgVOWDLock$.subscribe(
        flgVOWDLock => this.flgLock = flgVOWDLock
        );
  }

  PrepareReportData()
  {
    this.rptData.supplierAB=(this.SupplierAB==null || this.SupplierAB.trim()=='')?0: parseInt(this.SupplierAB.split('-')[0]);
    
    this.rptData.objectAccount=this.ObjectAccount;
    this.rptData.area=(this.Area==null||this.Area=='')? null:this.Area.split('-')[0];
    this.rptData.department=(this.Department==null||this.Department=='')?null:this.Department;
    this.rptData.year =  new Date(this.FrmDt).getFullYear().toString() ;//this.Year;
    this.rptData.FromDate = this.gd.convertToStandardDate(this.FrmDt);
    this.rptData.ToDate = this.gd.convertToStandardDate(this.ToDt);
    this.rptData.Contractid  = this.Contract;
      this.rptData.cmd = "" //Report visiblity change to all users
    this.rptData.ApprDate = this.gd.convertToStandardDate(this.ApprDt);
  
  }
 
   
  onselectSupplier(SupObj :Supplier) {     
    if (SupObj.SupplierAB != 0) {  
      this.SupplierAB = SupObj.SupplierAB.toString();
      this.SupName = SupObj.SupplierName +"-("+ SupObj.SupplierAB +")";  
      this.loading = false;  
      return true;
    }  
    else {  
      return false;  
    }
  }

  getDropAmtComnt()
  {
    this.reportService.getDropAmtComnt(this.rptData).subscribe(data=>{
      if(data !=null)
      {
      this.dropAmtComnt = data;
      this.Drop = this.dropAmtComnt.DropAmt;
      this.DropComments = this.dropAmtComnt.DropComments ;
      }
      this.rptData.Drop = this.dropAmtComnt.DropAmt;
      this.SearchDropAnalysisReport();
    });
  }
  CalcDropAmtComnt()
  {
    this.dropAmtComnt.DropAmt=this.Drop;
    this.dropAmtComnt.DropComments = this.DropComments;
    this.rptData.Drop = this.dropAmtComnt.DropAmt;
  }
  getAcurlYr()
  {
    
    for (var i = 2000; i <= 2040; i++) {
      this.getYrs.push(i.toString());
    }
    this.Year = new Date().getFullYear().toString();
  }

  getObjectAccount()
  {
    this.objectAccountsResult=this.gd.getAccountData();
    
   }

   // Push a search term into the observable stream.  
   searchObjAcnt(term: string): void {  
    if(term.length < 2)
    {
    this.getObjectAccount();
    }
      this.loading = true;  
      this.searchTermsObj.next(term); 
  }  
  
 onselectObjAcnt(ObjAcnt :string) {     
   if (ObjAcnt != '') {  
    this.ObjectAccount =ObjAcnt.split('-')[0].toString();
    this.ObjectAccountDesr =ObjAcnt; 
     this.loading = false;  
     return true;
   }  
   else {  
     return false;  
   }
 }



  OnSubmit(){
    this.reportService.updateDropAnalysis(this.resVowdList).subscribe(data=>{
      this.SubmitDropsComment();
      this.openAlertModal("Record Saved Successfully")
    },
    error=>{
      
    }
    );
  }
  SubmitDropsComment(){
if(this.resVowdList.length == 1){

  for(var i=0;i<=this.resVowdList.length-1;i++)
{
  this.dropAmtComnt.SupplierAB=(this.resVowdList[i]['SupplierAB']);
  this.dropAmtComnt.ObjectAccount=this.resVowdList[i]['ObjDescr'];
  this.dropAmtComnt.SupName=this.resVowdList[i]['SupplierABName'];
  this.dropAmtComnt.Period=this.resVowdList[i]['Period'];
  if(!this.Droptxt){
    this.dropAmtComnt.DropAmt=this.Drop;
  }else{
    this.dropAmtComnt.DropAmt=this.Adjust;
  }
  
  this.dropAmtComnt.Area=this.resVowdList[i]['Area_Code']+"-"+this.resVowdList[i]['Area_description'];
  if(this.dropAmtComnt.Remarks == this.resVowdList[i]['Remarks'] || this.dropAmtComnt.Remarks == "undefined" || this.dropAmtComnt.Remarks == "" )
  {
    this.dropAmtComnt.DropID = 0;
  }else
  {
    this.dropAmtComnt.DropID = 0;
  }
  this.dropAmtComnt.Remarks = this.resVowdList[i]['Remarks'];
      
      this.dropAmtComnt.FromDate =this.gd.convertToStandardDate(this.FrmDt);
      this.dropAmtComnt.ToDate =this.gd.convertToStandardDate(this.ToDt);
      this.dropAmtComnt.CreatedBy= this.user.ProvisioningID;      
      this.reportService.AddDropAmtComnt(this.dropAmtComnt).subscribe(data=>{
      },
      error=>{
      
      }
      );
  }
}
else{
  for(var i=0;i<=this.resVowdList.length-1;i++)
{
  this.dropAmtComnt.SupplierAB=(this.resVowdList[i]['SupplierAB']);
  this.dropAmtComnt.ObjectAccount=this.resVowdList[i]['ObjDescr'];
  this.dropAmtComnt.SupName=this.resVowdList[i]['SupplierABName'];
  this.dropAmtComnt.Period=this.resVowdList[i]['Period'];  
  this.dropAmtComnt.DropAmt=this.ConvertToInt(this.FractionDrop[i]) ; 
  
  
  
  this.dropAmtComnt.Area=this.resVowdList[i]['Area_Code']+"-"+this.resVowdList[i]['Area_description'];
  if(this.dropAmtComnt.Remarks == this.resVowdList[i]['Remarks'] || this.dropAmtComnt.Remarks == "undefined" || this.dropAmtComnt.Remarks == "" )
  {
    
    this.dropAmtComnt.DropID = 0;
  }else
  {
    this.dropAmtComnt.DropID = 0;
  }
  this.dropAmtComnt.Remarks = this.resVowdList[i]['Remarks'];
    
      this.dropAmtComnt.FromDate =this.gd.convertToStandardDate(this.FrmDt);
      this.dropAmtComnt.ToDate =this.gd.convertToStandardDate(this.ToDt);
      this.dropAmtComnt.CreatedBy= this.user.ProvisioningID;      
      this.reportService.AddDropAmtComnt(this.dropAmtComnt).subscribe(data=>{
      },
      error=>{
       
      }
      );
  }
}

}
  openAlertModal(strmsg: string) {
    const modalRef = this.modalService.open(ModalPopupAlertComponent);
    modalRef.componentInstance.strText = strmsg;
    modalRef.result.then((result) => {
    }, (reason) => {
    });   
  }

  CalculateAccural(dropAnalysis : any, checked:boolean) {
      this.reportService.CalculateAccural(dropAnalysis).subscribe(data=>{
      
        let itemIndex = this.dropAnalysisResult.findIndex(item => item.AccrualID == dropAnalysis.AccrualID);
        this.dropAnalysisResult[itemIndex] = data;
        this.dropAnalysisResult[itemIndex].selected = checked;
      });

    
  }
  
  pageChanged(event: any){
    this.config.currentPage = event;
  }

  EnableText(){
    this.Droptxt = !this.Droptxt;
    this.Adjustmentxt = !this.Adjustmentxt;
    if(this.Droptxt)
    {
      this.Drop = 0;
    }
    if(this.Adjustmentxt)
    {
      this.Adjust = 0;
    }
  }

  ConvertToInt(val: any){
    return parseFloat(val);
  }

}
